<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Portal Organization',
                searchable: true,
                sortable: true,
            },
            {
                value: 'radio_count',
                label: 'Radios',
                sortable: false,
                searchable: false,
            },
            {
                value: 'authorized_premium_radio_count',
                label: 'Authorized Basic Radios',
                sortable: false,
                searchable: false,
                tooltip: 'Radios are authorized to be premium, but are not yet upgraded',
            },
            {
                value: 'premium_radio_count',
                label: 'Premium Radios',
                sortable: false,
                searchable: false,
                tooltip: 'Radios have been upgraded to premium',
            },
        ]"
        :title="'Radios'"
        model="radios"
        fetchModel="organizations/radios"
        :createText="createText"
        :options="options"
        data-test-id="organization-radio-summary-table"
        :optionsComponent="optionsComponent"
        :noResultsText="noResultsText"
        :showTextSearch="false"
        :filters="filters"
        paginationTitle="organizations"
    >
        <template #disclaimer>
            <p class="disclaimer">*Only organizations with radios are shown</p>
        </template>

        <template #navigation>
            <section class="tabs">
                <button
                    class="active"
                    data-test-id="radio-summary-table-button"
                    @click="goToSummary"
                >
                    Organization Summary
                </button>
                <button
                    data-test-id="all-radios-table-button"
                    @click="goToRadios"
                >
                    View All Radios
                </button>
            </section>
        </template>

        <template #search>
            <section class="organization-selector">
                <organization-selector
                    :allowClear="true"
                    placeholder="Filter By Org"
                    :organizationId="selectedOrganizationId"
                    data-test-id="organization_radio_summary_organization_selector"
                    @update="organizationSelected"
                />
            </section>
        </template>
    </index-table>
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'
import OrganizationSelector from '@/components/OrganizationSelector.vue'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    components: {
        IndexTable,
        OrganizationSelector,
    },

    mixins: [needsOrganizationSlug],

    data() {
        let selectedOrganizationId = null

        if (this.$route.query.organization_id) {
            selectedOrganizationId = parseInt(this.$route.query.organization_id, 10)
        }
        return {
            optionsComponent: 'OrganizationRadioSummaryActions',
            selectedOrganizationId,
        }
    },

    computed: {
        filters() {
            const result = {}
            if (this.selectedOrganizationId !== null)
                return {
                    organization_id: this.selectedOrganizationId,
                }

            return result
        },
        noResultsText() {
            if (this.selectedOrganizationId !== null) {
                return 'The selected organization does not have any radios to view'
            }

            return 'There are no organizations with radios'
        },
        createText() {
            let result = ''

            const { hasPermission } = this.$store.getters

            // only show create new if viewing as super admin and can create an app
            if (!this.organizationSlug && hasPermission('create radios')) {
                result = 'Create Radio'
            }

            return result
        },

        options() {
            const result = []
            const { hasPermission } = this.$store.getters

            if (!this.organizationSlug) {
                if (hasPermission('upload radios')) {
                    result.push('importable')
                }
            }

            return result
        },
    },

    methods: {
        goToRadios() {
            this.$router.push('/radios')
        },

        goToSummary() {
            this.$router.push('/radios/summary')
        },

        organizationSelected(id) {
            this.selectedOrganizationId = id
        },
    },
}
</script>
<style lang="scss">
.organization-selector {
    width: 320px;
    top: 7px;
    position: relative;

    input {
        background-color: #fff;
        color: #000;
        height: auto;
        border-width: 0px;
    }
}

.tabs {
    margin-top: 30px;
    margin-left: 30px;
}

.tabs button {
    border: 1px solid #888;
    color: #fff;
    font-size: 14px;
    background-color: transparent;
    padding: 10px 12px;
    width: 256px;
    height: 40px;
    cursor: pointer;
}

.tabs button:first-child {
    border-radius: 8px 0px 0px 8px;
}

.tabs button:last-child {
    border-radius: 0px 8px 8px 0px;
    left: -1px;
    position: relative;
}

.tabs button.active {
    background-color: #212628;
}
</style>
